"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScriptLoader = void 0;

var uuid_1 = require("./uuid");

var createState = function createState() {
  return {
    listeners: [],
    scriptId: (0, uuid_1.generateUUID)('tekie-ce-script'),
    scriptLoading: false,
    scriptLoaded: false
  };
};

var CreateScriptLoader = function CreateScriptLoader() {
  var state = createState();

  var injectScriptTag = function injectScriptTag(scriptId, doc, url, async, defer, callback) {
    var scriptTag = doc.createElement('script');
    scriptTag.referrerPolicy = 'origin';
    scriptTag.type = 'application/javascript';
    scriptTag.id = scriptId;
    scriptTag.src = url;
    scriptTag.async = async;
    scriptTag.defer = defer;

    var handler = function handler() {
      scriptTag.removeEventListener('load', handler);
      callback();
    };

    scriptTag.addEventListener('load', handler);

    if (doc.head) {
      doc.head.appendChild(scriptTag);
    }
  };

  var load = function load(doc, url, async, defer, delay, callback) {
    var scriptTagInjection = function scriptTagInjection() {
      return injectScriptTag(state.scriptId, doc, url, async, defer, function () {
        state.listeners.forEach(function (fn) {
          return fn();
        });
        state.scriptLoaded = true;
      });
    };

    if (state.scriptLoaded) {
      callback();
    } else {
      state.listeners.push(callback);

      if (!state.scriptLoading) {
        state.scriptLoading = true;

        if (delay > 0) {
          setTimeout(scriptTagInjection, delay);
        } else {
          scriptTagInjection();
        }
      }
    }
  }; // Only to be used by tests.


  var reinitialize = function reinitialize() {
    state = createState();
  };

  return {
    load: load,
    reinitialize: reinitialize
  };
};

var ScriptLoader = CreateScriptLoader();
exports.ScriptLoader = ScriptLoader;